import Header from './Header'
import { Outlet, matchPath, useLocation } from 'react-router-dom'

// If changes, be sure to copy to Error.js

const Layout = () => {
  const location = useLocation()

  const hideNavBarRoutes = [
    '/', 
    '/questionnaire', 
  ]
  const shouldShowNav = !hideNavBarRoutes.some(pattern => (
    matchPath({ path: pattern, end: true }, location.pathname)
  ))
  
  const hideHeader = [
    '/prompt/:promptId/canvas', 
  ]
  const shouldShowHeader = !hideHeader.some(pattern => (
    matchPath({ path: pattern, end: true }, location.pathname)
  ))

  return (
    <div id="flex-layout">
        {shouldShowHeader && <Header shouldShowNav={shouldShowNav} />}
        <main id="outlet-layout" className={shouldShowNav && shouldShowHeader ? 'bottom-nav' : ''}>
            <Outlet />
        </main>
    </div>
  )
}

export default Layout